module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qrepr6-c37133bee195a1be2540b91d9d6cac26.jpg";